import StripeStyles from '../../styles/layout/StripeStyles.module.scss';

const Stripe = ({ children, stripeColor }) => {
  return <div className={StripeStyles.holder} style={{background: `${stripeColor}`, padding: `2rem 0 1.5rem`}}>{children}</div>;
};

export default Stripe;
